import { trackError } from '@billy/track-error'

import { ExternalInvoiceBalanceModifierReference } from '../elements/InvoiceViewActions/enums/ExternalInvoiceBalanceModifierReference'

const externalInvoiceBalanceModifierReferenceValues = Object.values(ExternalInvoiceBalanceModifierReference) as string[]

interface BalanceModifierReferenceResult {
  modifierType: ExternalInvoiceBalanceModifierReference | undefined
  modifierId: string | undefined
}

export const getExternalInvoiceBalanceModifierReference = (
  modifierReference?: string | null,
): BalanceModifierReferenceResult | undefined => {
  const [modifierType, modifierId] = (modifierReference || '').split(':')

  if (!externalInvoiceBalanceModifierReferenceValues.includes(modifierType)) {
    trackError('Passed modifierReference type is not in the ExternalInvoiceBalanceModifierReference enum')
    return undefined
  }

  return { modifierType: modifierType as ExternalInvoiceBalanceModifierReference, modifierId }
}
